module.exports = __webpack_public_path__ + "img/xyk.0c956827.png";